<template>
	<div :style="{ width: `${pWidth}px` }">
		<img class="relative w-full" alt="" src="images/1x_images/cell-blurred.png" srcset="images/2x_images/cell-blurred.png 2x" />
	</div>
</template>

<script>
/* eslint-disable */

export default {
	props: {
		pWidth: 0,
	},
	data() {
		return {};
	},
	methods: {},
	mounted() {},
};
</script>

<style scoped></style>
